import React from "react";
import classNames from "classnames";

import ZoneParametersHelper, {
  ZONE_PARAMETER_TYPES
} from "../../../../../../lib/UniversalTable/RendererHelpers/ZoneParametersHelper";

const ZoneParameters = ({ resultMetaData, stackZoneEdges = false }) => {
  const zoneType = ZoneParametersHelper.getZoneType(resultMetaData);
  const edges = ZoneParametersHelper.getEdges(resultMetaData);

  if (!edges) {
    return null;
  }

  return (
    <div
      className={classNames({
        "inline-block px-2 py-1 -mx-2 -my-1 text-white rounded-0.75": !!zoneType,
        "bg-green": zoneType === ZONE_PARAMETER_TYPES.DEMAND,
        "bg-red-2": zoneType === ZONE_PARAMETER_TYPES.SUPPLY
      })}
    >
      {stackZoneEdges ? (
        <>
          <div>{edges.bottom} -</div>
          <div>{edges.top}</div>
        </>
      ) : (
        <span style={{ whiteSpace: "nowrap" }}>
          {ZoneParametersHelper.render(resultMetaData)}
        </span>
      )}
    </div>
  );
};

ZoneParameters.shouldRenderDash = ZoneParametersHelper.shouldRenderDash;

export default ZoneParameters;
